/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Pagination from 'components/atoms/pagination';
import colors from 'styles/colors';
import { Container } from './styles';

interface ModalLicitacaoMyHistoryProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  followups: any;
}

const ModalFollowupsMyHistory = (props: ModalLicitacaoMyHistoryProps) => {
  const { showModal, setShowModal, followups } = props;
  const [currentPage, setCurrentPage] = useState<number>(1);

  const indexOfLastPost = currentPage * 5;
  const indexOfFirstPost = indexOfLastPost - 5;

  const currentPosts = followups?.followups?.acompanhamentos?.slice(
    indexOfFirstPost,
    indexOfLastPost,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };
  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Licitação</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <p className="font-weight-bold">Objeto</p>
                  <p>{followups?.followups?.objeto}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Nº ConLicitação</p>
                  <p>{followups?.followups?.id}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Data</p>
                  <p>{moment(followups?.followups?.data_validade).format('DD/MM/YYYY HH:mm')}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Edital</p>
                  <p>{followups?.followups?.edital}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Processo</p>
                  <p>{followups?.followups?.processo}</p>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Órgão</p>
                  <p>{followups?.followups?.orgao?.nome}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Cidade</p>
                  <p>
                    {followups?.followups?.orgao?.cidade} / {followups?.followups?.orgao?.estado}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="p-3">
              <p className="font-weight-bold ml-2">Total de {currentPosts.length} acompanhamento</p>
              <Container>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Síntese</th>
                      <th scope="col">Data da Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPosts?.map((acompanhamento: any) => (
                      <tr>
                        <td title={acompanhamento?.sintese}>{acompanhamento?.sintese}</td>
                        <td>{moment(acompanhamento?.data_fonte).format('DD/MM/YYYY')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Container>
            </div>
            <div className="row d-print-none">
              <div className="col-md-12 px-4 mb-5">
                <Pagination
                  postsPerPage={5}
                  totalPosts={currentPosts.length}
                  paginate={paginate}
                  currentPage={currentPage}
                  firstAndLastPage
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalFollowupsMyHistory;
